interface Props {
  color?: string;
}

const FaqIcon = ({ color }: Props) => (
  <svg width="22" height="20" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 20">
    <path
      fill={color || "currentColor"}
      fillRule="evenodd"
      d="M2 3v6a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1M0 9a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3a3 3 0 0 0-3 3zm2 7a1 1 0 1 1 0-2h12a1 1 0 1 1 0 2zm0 4a1 1 0 1 1 0-2h12a1 1 0 1 1 0 2z"
      clipRule="evenodd"
    />
  </svg>
);
export default FaqIcon;
